'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIMain = require('../layout/UIMain');

var _UIMain2 = _interopRequireDefault(_UIMain);

var _customRenderer = require('../utils/propTypes/customRenderer');

var CustomRenderer = _interopRequireWildcard(_customRenderer);

var _sizes = require('HubStyleTokens/sizes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Outer = _styledComponents2.default.div.withConfig({
  displayName: 'UIAbstractPageGridContent__Outer'
})(['display:flex;flex-wrap:nowrap;margin-left:-16px;margin-right:-16px;@media only screen and (max-width:', '){flex-wrap:wrap;}'], _sizes.GRID_BREAKPOINT_SMALL);

var Sidebar = _styledComponents2.default.div.withConfig({
  displayName: 'UIAbstractPageGridContent__Sidebar'
})(['flex:0 0 33%;max-width:224px;padding-left:16px;padding-right:16px;position:relative;@media only screen and (max-width:', '){flex-basis:100%;max-width:none;}'], _sizes.GRID_BREAKPOINT_SMALL);

var MainContainer = _styledComponents2.default.div.withConfig({
  displayName: 'UIAbstractPageGridContent__MainContainer'
})(['flex:1 0 0%;max-width:', ';padding-left:16px;padding-right:16px;position:relative;@media only screen and (max-width:679px){max-width:', ';}@media only screen and (max-width:', '){flex-basis:100%;max-width:100%;}'], function (_ref) {
  var hasSidebar = _ref.hasSidebar;
  return hasSidebar ? 'calc(100% - 224px)' : '100%';
}, function (_ref2) {
  var hasSidebar = _ref2.hasSidebar;
  return hasSidebar && '67%';
}, _sizes.GRID_BREAKPOINT_SMALL);

var STICKY_STYLES = (0, _styledComponents.css)(['height:100vh;margin-left:-', ';overflow-y:auto;padding-left:', ';position:sticky;top:0;@media only screen and (max-width:', '){height:auto;}'], _sizes.NAV_ITEM_PADDING_LEFT, _sizes.NAV_ITEM_PADDING_LEFT, _sizes.GRID_BREAKPOINT_SMALL);

var SidebarContainer = _styledComponents2.default.div.withConfig({
  displayName: 'UIAbstractPageGridContent__SidebarContainer'
})(['', ';'], function (props) {
  return props.stickySidebar && STICKY_STYLES;
});

function renderSidebar(sidebar, stickySidebar) {
  if (!sidebar) return null;

  return _react2.default.createElement(
    Sidebar,
    null,
    _react2.default.createElement(
      SidebarContainer,
      { stickySidebar: stickySidebar },
      CustomRenderer.render(sidebar)
    )
  );
}

exports.default = _react2.default.createClass({
  displayName: 'UIAbstractPageGridContent',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    children: _react.PropTypes.node,
    sidebarComponent: CustomRenderer.propType,
    stickySidebar: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      stickySidebar: false
    };
  },
  render: function render() {
    var _props = this.props,
        children = _props.children,
        sidebarComponent = _props.sidebarComponent,
        stickySidebar = _props.stickySidebar;


    return _react2.default.createElement(
      Outer,
      null,
      renderSidebar(sidebarComponent, stickySidebar),
      _react2.default.createElement(
        MainContainer,
        { hasSidebar: !!sidebarComponent },
        _react2.default.createElement(
          _UIMain2.default,
          { flush: true },
          children
        )
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/page/UIAbstractPageGridContent.js
// module id = 596
// module chunks = 171